import { assign, pick } from "lodash";
import { get, easyHttp, alertMultiMessage } from "@/assets/common/request";
import{ findComponentUpward, findComponentDownward } from '@/assets/common/component';
import moment from "moment";
import {Juris} from "@/directives/Juris";
export default {
    props: {
		defaultFormData: {
			type: Object,
			default: function() {
				return {};
			},
		},
	},
    data() {
        return {
            saveLoading: false,
            formLoading: false,
            formData: this.defaultFormData || {}
        }
    },
    methods: {
        _loadFormData(url, attributes, obj) {
            this.formLoading = true;
            return get(url).then(({data}) => {
                if(attributes && attributes.length > 0) {
                    return this.formData = assign({}, pick(data, attributes), obj);
                }else {
                    return this.formData = assign({}, data, obj);
                }
            }).finally(() => {
                this.formLoading = false;
            });
        },
        getFormData() {
            if(this.saveBefore) {
                this.saveBefore(formData);
            }
            const formData = assign({}, this.formData);
            return formData;
        },
        _doSaveForm(form, url, method) {
            let formComponent = this._findFormComponent(form);
            formComponent.validate((valid) => {
				if (valid) {
                    const requestConfig = {
                        method,
                        url,
                        data: this.getFormData(),
                    }
                    this.saveLoading = true;
                    easyHttp(requestConfig)
                    .then((data) => {
                        this.saveLoading = false;
                        this.doClose();
						this.$emit("search");
						alertMultiMessage(data);
                        if(this.doSaveAfter) {
                            this.doSaveAfter(data);
                        }
                    })
                    .finally(() => {
                        this.saveLoading = false;
                        this.formData = {};
                    });
				} else {
					return false;
				}
			});
        },
        _findFormComponent(form) {
            let formComponent = form;
            if(!formComponent) {
                formComponent = this.$refs.form;
            }
            if(!formComponent) {  
                formComponent = findComponentDownward(this, 'ElForm');
            }
            if(!formComponent) {
                console.error('无法使用该内置方法，原因：获取不到表单');
                return;
            }
            return formComponent;
        },
        doClose() {
            const dialog = findComponentUpward(this, "ElDialog");
            if(dialog) {
                dialog.$emit('update:visible', false);
                return true;
            }
            return false;
        },
        _getDictLabel(dict, value) {
			if (dict && value) {
				const item = dict.find((e) => e.value == value);
				return item.label;
			}else {
                return '';
            }
        },
        isPermit(permitFlag) {
            if(permitFlag) {
                return Juris(permitFlag.toString());
            }
            return false;
        }
    },
    filters: {
        dictLabel(value, dict) {
            if (dict && value) {
				const item = dict.find((e) => e.value == value);
				return item.label;
			}else {
                return '';
            }
        },
        toYuan(value) {
            let val = value;
            if(val) {
                if(!Number.isFinite(val)) {
                    val = Number.parseFloat(val);
                    if(Number.isNaN(val)) {
                        return value;
                    }
                }
                return round(divide(value, 100), 2);
            }else {
                return value;
            }
        },
        dateFmt(value, fmt) {
            if(value) {
                try {
                    return moment(value).format(fmt);
                }catch(e) {
                    console.error(e)
                    return "";
                }
            }else {
                "";
            }
        }
    }
}